module.exports = __webpack_public_path__ + "Simple-Line-Icons.eot";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = 488
// module chunks = 8